<template>
  <div class="rootDiv">
    <div>
      <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white;">
        <div style="float: left;">
          <img src="../../../assets/images/32/menuType.png" @click="showPopup"
               style="padding: 0;margin-top: 0.5rem;margin-right: 0.5rem;margin-left: 0.5rem" height="20"
               width="20"
               slot="icon" alt="">
        </div>
        <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
          <div class="mint-searchbar" style="padding: 0">
            <div class="mint-searchbar-inner">
              <i class="mintui mintui-search"/>
              <input type="search" placeholder="搜索" class="mint-searchbar-core" style="color: black" v-model="searchKey"/>
              <a class="mint-searchbar-cancel" style="display: none;">取消</a>
            </div>
            <div class="mint-search-list" style="display: none;">
              <div class="mint-search-list-warp"/>
            </div>
          </div>
        </div>
        <div style="float: left;">
          <img src="../../../assets/images/32/search.png" @click="Search"
               style="margin-right:20px ;padding: 0;margin-top: 0.5rem" height="20"
               width="20"
               slot="icon" alt="">
        </div>
      </header>
    </div>
    <div :style="classtest" style="margin-top: 45px">
      <Loadmore :top-method="loadTop" :bottom-method="loadBottom" :auto-fill="false" ref="loadmore">
        <ul v-for="item in recipeList" :key="item.iD" class="one">
          <li class="two">
            <div style="float: left;padding: 0.5rem;" @click="details(item.iD)">
              <img class="three" :src="item.cPTP" alt="" :width="imgWidth">
              <br>
              <Span style="font-size: 1.2rem;color: #2986de">{{ item.cPMC | ellipsis(6) }}</Span>
              <br>
              <Span style="font-size: 0.8rem">{{ item.cPBQ | ellipsis(12) }}</Span>
            </div>
          </li>
        </ul>
      </Loadmore>
    </div>
    <div>
      <span v-if="noMore">没有更多了...</span>
    </div>
    <Popup style="width: 90%;height: 90%;background-color: lightgrey;  overflow-y: scroll;"
           v-model="popupVisible"
           popup-transition="popup-fade">
      <Tabs>
        <Tab :title="item.mC" v-for="item in typeList" :key="item.iD">
          <Button round type="info" v-for="child in item.list" :key="child.iD" @click="SearchByType(child.iD)"
                  style="margin: 0.2rem;padding: 5px;width: 3.5rem;">{{ child.mC }}
          </Button>
        </Tab>
      </Tabs>
    </Popup>
    <div class="empty-div">
      <div>
        <img src="../../../assets/images/no_data.png" v-if="showEmptyImage" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
import {Indicator, Loadmore, Popup} from "mint-ui";
import {Tab, Tabs, Button} from 'vant';
import 'vant/lib/tabs/index.css'
import 'vant/lib/tab/index.css'
import 'vant/lib/button/index.css'

export default {
  name: "Recipe",
  filters: {
    ellipsis(value, lenth) {
      if (!value) return ''
      if (value.length > lenth) {
        return value.slice(0, lenth) + '...'
      }
      return value
    }
  },
  data() {
    return {
      showEmptyImage: false,
      typeList: [],
      selected: '1',
      popupVisible: false,
      imgWidth: document.documentElement.clientWidth * 0.5 - 20,
      classtest:
          {
            overflow: 'scroll',
            height: (document.documentElement.clientHeight - 60).toString() + 'px',
          },
      searchAction: 'Recommend',
      noMore: false,
      randomType: null,
      pageSize: 30,
      pageIndex: 1,
      searchKey: null,
      selectedType: null,
      token: localStorage.getItem('token'),
      searchRecipeUrl: '/api/otherapi/searchRecipePage',
      getRecommendRecipeUrl: '/api/otherapi/getRecommendRecipe',
      getRecipeTypeUrl: '/api/otherapi/getRecipeType',
      getRecipeByTypeUrl: '/api/otherapi/getRecipeByType',
      recipeList: [],
      recipeItem: {
        cPBQ: null,
        cPMC: null,
        cPPJ: null,
        cPTP: null,
        iD: null,
        lXID: null,
        lXMC: null,
        pRSC: null,
        sHRS: null,
        zBSC: null,
        material: [],
        process: [],
      },
      process: {
        bZNM: null,
        bZMS: null,
        bZTP: null,
        sSCP: null,
        sX: null,
      },
      material: {
        cLNM: null,
        cLMC: null,
        cLLX: null,
        cLYL: null,
        sSCP: null,
      },
    }
  },
  components: {
    Loadmore, Popup, Tab, Tabs, Button
  },
  mounted() {
    this.getRecommendRecipe(false)
    this.getRecipeTypeList()
  },
  methods: {
    SearchByType(typeID) {
      let that = this
      that.popupVisible = false
      that.searchAction = 'SearchByType'
      that.pageIndex = 1
      that.selectedType = typeID
      Indicator.open({
        text: '搜索菜谱中...',
        spinnerType: 'fading-circle'
      });
      that.TypeSelected(false)
    },
    TypeSelected(isLoadmore) {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getRecipeByTypeUrl,
        params: {typeID: that.selectedType, pageIndex: that.pageIndex, pageSize: that.pageSize},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            Indicator.close();
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              let responseData = response.data['responseData']
              let list = responseData['data']
              if (that.pageIndex === 1) {
                that.recipeList = list
              } else {
                that.recipeList = that.recipeList.concat(list)
              }
              that.showEmptyImage = that.recipeList.length <= 0;
              let isLast = responseData['isLast'].toString() !== 'false';
              if (!isLast) {
                that.pageIndex++
                that.noMore = false
              } else {
                that.noMore = true
              }
            }
            if (isLoadmore)
              that.$refs.loadmore.onBottomLoaded();
          }
      ).catch(response => {
        Indicator.close();
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
        if (isLoadmore)
          that.$refs.loadmore.onBottomLoaded();
      })
    },
    getRecipeTypeList() {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getRecipeTypeUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.typeList = response.data['responseData']
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    showPopup() {
      this.popupVisible = true
    },
    getRecommendRecipe(isLoadmore) {
      Indicator.open({
        text: '数据加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getRecommendRecipeUrl,
        params: {randomType: that.randomType, pageIndex: that.pageIndex, pageSize: that.pageSize},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            Indicator.close()
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              let responseData = response.data['responseData']
              let list = responseData['data']
              if (that.pageIndex === 1) {
                that.recipeList = list
              } else {
                that.recipeList = that.recipeList.concat(list)
              }
              that.showEmptyImage = that.recipeList.length <= 0;
              let isLast = responseData['isLast'].toString() !== 'false';
              if (!isLast) {
                that.pageIndex++
                that.randomType = responseData['randomType']
                that.noMore = false
              } else {
                that.noMore = true
              }
            }
            if (isLoadmore)
              that.$refs.loadmore.onBottomLoaded();
          }
      ).catch(response => {
        Indicator.close()
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
        if (isLoadmore)
          that.$refs.loadmore.onBottomLoaded();
      })
    },
    loadBottom() {
      if (this.noMore === true) {
        this.$refs.loadmore.onBottomLoaded();
        return;
      }
      if (this.searchAction === 'Recommend')
        this.getRecommendRecipe(true)
      else if (this.searchAction === 'SearchByKey')
        this.doSearch(true)
      else
        this.TypeSelected(true)
    },
    loadTop() {
      let that = this
      that.pageIndex = 1
      that.randomType = null
      that.getRecommendRecipe(false)
      that.$refs.loadmore.onTopLoaded();
    },
    details(id) {
      this.$router.push({name: 'm_recipe_details', params: {id: id}})
    },
    Search() {
      let that = this
      that.pageIndex = 1
      if (that.searchKey === null || that.searchKey === '') {
        that.searchAction = 'Recommend'
        that.getRecommendRecipe(false)
        return
      }
      that.searchAction = 'SearchByKey'
      Indicator.open({
        text: '搜索菜谱中...',
        spinnerType: 'fading-circle'
      });
      this.doSearch(false)
    },
    doSearch(isLoadmore) {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.searchRecipeUrl,
        params: {key: that.searchKey, pageIndex: that.pageIndex, pageSize: that.pageSize},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            Indicator.close();
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              let responseData = response.data['responseData']
              let list = responseData['data']
              if (that.pageIndex === 1) {
                that.recipeList = list
              } else {
                that.recipeList = that.recipeList.concat(list)
              }
              that.showEmptyImage = that.recipeList.length <= 0;
              let isLast = responseData['isLast'].toString() !== 'false';
              if (!isLast) {
                that.pageIndex++
                that.noMore = false
              } else {
                that.noMore = true
              }
            }
            if (isLoadmore)
              that.$refs.loadmore.onBottomLoaded();
          }
      ).catch(response => {
        Indicator.close();
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
        if (isLoadmore)
          that.$refs.loadmore.onBottomLoaded();
      })
    },
  },
}
</script>

<style lang="less" scoped>

.one {
  width: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.right-menu {
  padding: 0;
}

.two {
  float: left;
}

.empty-div {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate3d(-50%, -50%, 0);
}

.three {
  border-radius: 10px;
}

.rootDiv {
  margin-top: -0.5rem;
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}


.addbutton {
  background: lightseagreen;
}

.wrapper {
  overflow-y: scroll;
}

/deep/ .mint-loadmore-bottom {
  clear: both
}

/deep/ .mint-searchbar {
  padding: 1px;
  background-color: #dddddd;
}
</style>
